import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import { R1, R2, R3, R4, L1, L2, L3, L4 } from './parts.js';
import styles from './Wreath.module.scss.js';

var Wreath = (function (_super) {
    __extends(Wreath, _super);
    function Wreath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Wreath.prototype.render = function () {
        var _a;
        var color = '#fff';
        if (this.props.color) {
            color = this.props.color;
        }
        return (React.createElement("div", { className: classNames(styles.wrapper, (_a = this.props) === null || _a === void 0 ? void 0 : _a.className), onClick: this.props.onClick },
            React.createElement(R1, { color: color, className: styles.part + " " + (!!this.props.isActive ? '' : styles.R1) }),
            React.createElement(R2, { color: color, className: styles.part + " " + (!!this.props.isActive ? '' : styles.R2) }),
            React.createElement(R3, { color: color, className: styles.part + " " + (!!this.props.isActive ? '' : styles.R3) }),
            React.createElement(R4, { color: color, className: styles.part + " " + (!!this.props.isActive ? '' : styles.R4) }),
            React.createElement(L1, { color: color, className: styles.part + " " + (!!this.props.isActive ? '' : styles.L1) }),
            React.createElement(L2, { color: color, className: styles.part + " " + (!!this.props.isActive ? '' : styles.L2) }),
            React.createElement(L3, { color: color, className: styles.part + " " + (!!this.props.isActive ? '' : styles.L3) }),
            React.createElement(L4, { color: color, className: styles.part + " " + (!!this.props.isActive ? '' : styles.L4) })));
    };
    return Wreath;
}(React.Component));

export { Wreath as default };
//# sourceMappingURL=Wreath.js.map
